import React from 'react';
import { Form } from 'react-bootstrap';

type RadioButtonProps = {
  label: any;
  type?: 'radio' | 'checkbox';
  value: any;
  checked: any;
  checkBoxClass?: any;
  mainClassName?: any;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  id?: string;
};

const RadioButton = ({ 
  label, 
  type = "radio", 
  value, 
  checked, 
  onChange, 
  name, 
  id = undefined,
  mainClassName = undefined, 
  checkBoxClass = undefined 
}: RadioButtonProps) => {
  const className = `${checked && type !== 'checkbox' ? 'checked-label ' : checkBoxClass} sub_heading fw-600 grey_subtext1 clickable`;
  
  // Generate a unique ID if not provided
  const inputId = id || `${name}-${value}`;

  return (
    <div className={`${mainClassName ? mainClassName : ""} custom_radio`}>
      <Form.Check
        required
        id={inputId}
        type={type}
        label={label}
        value={value}
        name={name}
        checked={checked}
        onChange={onChange}
        className={className}
      />
    </div>
  );
};

export default RadioButton;